import { UtilitarioService } from "@app/services/utilitario.service";

export class Cheque {

  Id: number;
  Banco: string;
  CaixaId: number;
  Agencia: string;
  Conta: string;
  ChequeNum: string;
  Titular: string;
  Valor: number;
  DataEmissao: string;
  DataVencimento: string;
  Compensado: boolean;
  Proprio: boolean;
  UnidadeId: number;
  Ativo: boolean;
  BancoId: number;

  constructor() {
    this.DataVencimento = UtilitarioService.retornaDataAtualMaisDias(0);
  }
}
